export interface CampaignTemplate {
  id: string;
  name: string;
  preview: string;
  generateHtml: (params: { heading: string; body: string; ctaText?: string; ctaUrl?: string }) => string;
}

export const campaignTemplates: CampaignTemplate[] = [
  {
    id: 'classic',
    name: 'Classic Elegance',
    preview: 'Centered logo, serif heading, single CTA button',
    generateHtml: ({ heading, body, ctaText, ctaUrl }) => `
      <!DOCTYPE html>
      <html>
      <head><meta charset="UTF-8"></head>
      <body style="margin:0;padding:0;background:#F2F2F2;font-family:Georgia,serif;">
        <div style="max-width:600px;margin:0 auto;background:#FFFFFF;padding:48px 40px;">
          <div style="text-align:center;font-size:22px;letter-spacing:4px;color:#0D0D0D;margin-bottom:48px;">
            LANRE SAVAGE
          </div>
          <h1 style="font-size:26px;color:#0D0D0D;margin-bottom:24px;text-align:center;font-weight:400;">
            ${heading}
          </h1>
          <div style="font-size:14px;color:#2B2B2B;line-height:1.8;margin-bottom:32px;">
            ${body}
          </div>
          ${ctaText && ctaUrl ? `
          <div style="text-align:center;margin-bottom:32px;">
            <a href="${ctaUrl}" style="display:inline-block;background:#0D0D0D;color:#FFFFFF;padding:14px 36px;text-decoration:none;letter-spacing:2px;font-size:12px;text-transform:uppercase;">
              ${ctaText}
            </a>
          </div>` : ''}
          <div style="text-align:center;font-size:11px;color:#CFC7BD;margin-top:40px;border-top:1px solid #F2F2F2;padding-top:24px;">
            © ${new Date().getFullYear()} Lanre Savage. All rights reserved.
          </div>
        </div>
      </body>
      </html>
    `,
  },
  {
    id: 'editorial',
    name: 'Editorial Feature',
    preview: 'Full-width image banner, magazine-style layout',
    generateHtml: ({ heading, body, ctaText, ctaUrl }) => `
      <!DOCTYPE html>
      <html>
      <head><meta charset="UTF-8"></head>
      <body style="margin:0;padding:0;background:#FFFFFF;font-family:Georgia,serif;">
        <div style="max-width:600px;margin:0 auto;">
          <div style="background:#0D0D0D;color:#FFFFFF;text-align:center;padding:32px;letter-spacing:3px;font-size:18px;">
            LANRE SAVAGE
          </div>
          <div style="padding:48px 40px;">
            <p style="font-size:11px;letter-spacing:2px;color:#CFC7BD;text-transform:uppercase;margin-bottom:16px;">
              New From Lanre Savage
            </p>
            <h1 style="font-size:32px;color:#0D0D0D;margin-bottom:24px;font-weight:400;line-height:1.3;">
              ${heading}
            </h1>
            <div style="font-size:14px;color:#2B2B2B;line-height:1.8;margin-bottom:32px;">
              ${body}
            </div>
            ${ctaText && ctaUrl ? `
            <a href="${ctaUrl}" style="display:inline-block;border:1px solid #0D0D0D;color:#0D0D0D;padding:13px 36px;text-decoration:none;letter-spacing:2px;font-size:12px;text-transform:uppercase;">
              ${ctaText}
            </a>` : ''}
          </div>
          <div style="background:#F2F2F2;text-align:center;font-size:11px;color:#2B2B2B;padding:24px;">
            © ${new Date().getFullYear()} Lanre Savage. All rights reserved.
          </div>
        </div>
      </body>
      </html>
    `,
  },
  {
    id: 'minimal',
    name: 'Minimal Announcement',
    preview: 'Clean, text-focused, generous whitespace',
    generateHtml: ({ heading, body, ctaText, ctaUrl }) => `
      <!DOCTYPE html>
      <html>
      <head><meta charset="UTF-8"></head>
      <body style="margin:0;padding:60px 20px;background:#FFFFFF;font-family:'Helvetica Neue',Arial,sans-serif;">
        <div style="max-width:520px;margin:0 auto;text-align:center;">
          <p style="font-size:11px;letter-spacing:3px;color:#CFC7BD;text-transform:uppercase;margin-bottom:40px;">
            Lanre Savage
          </p>
          <h1 style="font-size:24px;color:#0D0D0D;margin-bottom:20px;font-weight:500;">
            ${heading}
          </h1>
          <div style="font-size:13px;color:#2B2B2B;line-height:1.8;margin-bottom:36px;">
            ${body}
          </div>
          ${ctaText && ctaUrl ? `
          <a href="${ctaUrl}" style="display:inline-block;background:#0D0D0D;color:#FFFFFF;padding:12px 32px;text-decoration:none;letter-spacing:1.5px;font-size:11px;text-transform:uppercase;">
            ${ctaText}
          </a>` : ''}
          <p style="font-size:10px;color:#CFC7BD;margin-top:60px;">
            © ${new Date().getFullYear()} Lanre Savage
          </p>
        </div>
      </body>
      </html>
    `,
  },
];